import { AppConfig, Environment } from '../app/models/app.model';

export const domains = ['dev.sign.ms-add-in.ajila.io'];
export const href = 'https://dev.sign.ms-add-in.ajila.io/';

export const config: AppConfig = {
  apiGateway: 'https://dev.sign.ms-add-in.ajila.io',
  env: Environment.DEV,
  appName: 'Swisscom Sign (Dev)',
};
